// extracted by mini-css-extract-plugin
export default {"statusMessageText":"StatusMessage_statusMessageText__z8mMP"};